import { lighten } from "polished";
import { ComponentProps } from "react";
import { IconType } from "react-icons/lib";
import styled from "styled-components";

export type IconButtonProps = {
  icon: IconType;
} & ComponentProps<typeof Button>;

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  color: ${(props) => props.theme.colors.body};
  background: none;
  border: 0;
  transition: all 0.3s ease;
  border-radius: 3px;
  cursor: not-allowed;

  &:not([disabled]) {
    cursor: pointer;
    &:hover,
    &:focus {
      outline: 0;
      background: ${(props) => props.theme.colors.grey1};
    }

    &:active {
      background: ${(props) => lighten(0.05, props.theme.colors.grey1)};
    }
  }

  &[disabled] {
    opacity: 0.5;
  }
`;

export function IconButton({ icon: Icon, ...props }: IconButtonProps) {
  return (
    <Button {...props}>
      <Icon />
    </Button>
  );
}
